import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

function SalairesHistorique() {

  const [depenses, setDepenses] =
    useState([]);

  const [personnel, setPersonnel] =
    useState([]);

  const [filterEmploye, setFilterEmploye] =
    useState("");

  const [filterMois, setFilterMois] =
    useState("");

  const [filterAnnee, setFilterAnnee] =
    useState("");

  const [page, setPage] =
    useState(1);

  const limit = 20;

  const navigate =
    useNavigate();

  useEffect(() => {
    fetchData();
  }, [page]);

  // =====================
  // FETCH
  // =====================

  const fetchData = async () => {

    try {

      const resDep =
        await api.get(
          `/depenses?page=${page}&limit=${limit}`
        );

      const resPers =
        await api.get(
          "/personnel"
        );

      setDepenses(
        resDep.data.data || []
      );

      setPersonnel(
        resPers.data || []
      );

    } catch (err) {

      console.error(err);

    }
  };

  // =====================
  // SECURE ARRAY
  // =====================

  const depensesArray =
    Array.isArray(depenses)
      ? depenses
      : depenses?.data || [];

  // =====================
  // SALAIRES ONLY
  // =====================

  const salaires =
    depensesArray.filter(
      (d) =>
        d.categorie ===
        "salaires"
    );

  // =====================
  // FILTERS
  // =====================

  const filtered =
    salaires.filter((d) => {

      const employe =
        personnel.find(
          (p) =>
            p.id ===
            d.personnel_id
        );

      const nom = employe
        ? `${employe.nom} ${employe.prenom}`
        : "-";

      const [
        year,
        month
      ] = (
        d.periode_salaire ||
        ""
      ).split("-");

      return (
        (!filterEmploye ||
          nom ===
            filterEmploye) &&
        (!filterMois ||
          month ===
            filterMois) &&
        (!filterAnnee ||
          year ===
            filterAnnee)
      );
    });

  // =====================
  // FORMAT
  // =====================

  const formatPeriode = (
    periode
  ) => {

    if (!periode) return "-";

    const [
      year,
      month
    ] = periode.split("-");

    const date =
      new Date(
        year,
        month - 1
      );

    return date.toLocaleString(
      "fr-FR",
      {
        month: "long",
        year: "numeric"
      }
    );
  };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 space-y-4 md:space-y-6 bg-gray-100 min-h-[100dvh]">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">

        <h2 className="text-2xl md:text-3xl font-semibold">
          Historique des salaires
        </h2>

        <button
          onClick={() =>
            navigate("/salaires")
          }
          className="bg-gray-700 text-white px-4 py-3 md:py-2 rounded-xl hover:bg-black transition w-full md:w-auto"
        >
          ← Retour
        </button>

      </div>

      {/* FILTERS */}
      <div className="bg-white p-4 rounded-2xl shadow grid grid-cols-1 md:grid-cols-3 gap-4">

        {/* EMPLOYE */}
        <select
          value={
            filterEmploye
          }
          onChange={(e) =>
            setFilterEmploye(
              e.target.value
            )
          }
          className="border p-3 rounded-xl outline-none focus:ring-2 focus:ring-blue-400"
        >

          <option value="">
            Tous les employés
          </option>

          {personnel.map(
            (p) => {

              const nom = `${p.nom} ${p.prenom}`;

              return (
                <option
                  key={p.id}
                >
                  {nom}
                </option>
              );
            }
          )}

        </select>

        {/* MOIS */}
        <select
          value={filterMois}
          onChange={(e) =>
            setFilterMois(
              e.target.value
            )
          }
          className="border p-3 rounded-xl outline-none focus:ring-2 focus:ring-blue-400"
        >

          <option value="">
            Tous les mois
          </option>

          {[
            [
              "01",
              "Janvier"
            ],
            [
              "02",
              "Février"
            ],
            [
              "03",
              "Mars"
            ],
            [
              "04",
              "Avril"
            ],
            [
              "05",
              "Mai"
            ],
            [
              "06",
              "Juin"
            ],
            [
              "07",
              "Juillet"
            ],
            [
              "08",
              "Août"
            ],
            [
              "09",
              "Septembre"
            ],
            [
              "10",
              "Octobre"
            ],
            [
              "11",
              "Novembre"
            ],
            [
              "12",
              "Décembre"
            ]
          ].map(
            ([
              val,
              label
            ]) => (
              <option
                key={val}
                value={val}
              >
                {label}
              </option>
            )
          )}

        </select>

        {/* ANNEE */}
        <input
          type="number"
          placeholder="Année (2026)"
          value={
            filterAnnee
          }
          onChange={(e) =>
            setFilterAnnee(
              e.target.value
            )
          }
          className="border p-3 rounded-xl outline-none focus:ring-2 focus:ring-blue-400"
        />

      </div>

      {/* MOBILE */}
      <div className="grid gap-3 md:hidden">

        {filtered.map((d) => {

          const employe =
            personnel.find(
              (p) =>
                p.id ===
                d.personnel_id
            );

          const nom =
            employe
              ? `${employe.nom} ${employe.prenom}`
              : "";

          return (
            <div
              key={d.id}
              className="bg-white rounded-2xl shadow p-4 border"
            >

              <div className="font-semibold text-base break-words">
                {nom}
              </div>

              <div className="text-sm text-gray-500 mt-1">
                {formatPeriode(
                  d.periode_salaire
                )}
              </div>

              <div className="text-lg font-bold text-blue-600 mt-2">
                {d.montant} $
              </div>

              <div className="text-sm mt-2">
                💳{" "}
                {d.mode_paiement ||
                  "-"}
              </div>

              <div className="text-xs text-gray-500 mt-2">
                {new Date(
                  d.date_depense
                ).toLocaleDateString()}
              </div>

            </div>
          );
        })}

      </div>

      {/* DESKTOP */}
      <div className="hidden md:block bg-white rounded-2xl shadow overflow-x-auto">

        <table className="min-w-full text-sm">

          <thead className="bg-gray-900 text-white">

            <tr>

              <th className="px-4 py-3 text-left">
                Employé
              </th>

              <th className="px-4 py-3 text-left">
                Période
              </th>

              <th className="px-4 py-3 text-left">
                Montant
              </th>

              <th className="px-4 py-3 text-left">
                Mode
              </th>

              <th className="px-4 py-3 text-left">
                Date paiement
              </th>

            </tr>

          </thead>

          <tbody>

            {filtered.map(
              (d) => {

                const employe =
                  personnel.find(
                    (p) =>
                      p.id ===
                      d.personnel_id
                  );

                const nom =
                  employe
                    ? `${employe.nom} ${employe.prenom}`
                    : "";

                return (
                  <tr
                    key={d.id}
                    className="border-t hover:bg-gray-50 transition"
                  >

                    <td className="px-4 py-3 font-medium">
                      {nom}
                    </td>

                    <td className="px-4 py-3">
                      {formatPeriode(
                        d.periode_salaire
                      )}
                    </td>

                    <td className="px-4 py-3 font-semibold">
                      {d.montant} $
                    </td>

                    <td className="px-4 py-3">
                      {d.mode_paiement ||
                        "-"}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap">
                      {new Date(
                        d.date_depense
                      ).toLocaleDateString()}
                    </td>

                  </tr>
                );
              }
            )}

          </tbody>

        </table>

      </div>

      {/* PAGINATION */}
      <div className="flex justify-center gap-3 flex-wrap">

        <button
          disabled={page === 1}
          onClick={() =>
            setPage(
              (prev) =>
                prev - 1
            )
          }
          className="px-4 py-2 bg-white rounded-xl shadow disabled:opacity-50"
        >
          Précédent
        </button>

        <span className="px-4 py-2 font-medium">
          Page {page}
        </span>

        <button
          onClick={() =>
            setPage(
              (prev) =>
                prev + 1
            )
          }
          className="px-4 py-2 bg-gray-800 text-white rounded-xl"
        >
          Suivant
        </button>

      </div>

    </div>
  );
}

export default SalairesHistorique;